<template>
	<div>
		<v-row>
			<v-col cols="12" md="6">
				<v-card color="#00a27c07" class="primary--text mx-auto card-login" max-width="400" elevation="0" outlined>
           
					<v-card-title class="text-h5 text-center py-10" >
						<v-row dense>
							<v-spacer></v-spacer>
							Acesso da agenda saúde
							<v-spacer></v-spacer>
						</v-row>
					</v-card-title>

					<v-card-text>
							<v-row dense>
								<v-col col='12' sm='8' offset-sm='2'>
									<v-text-field label="Usuário" id="input-user"
										:disabled="computedLoading" 
										v-model="login.username" 
										outlined dense
										:messages="veeErrors.first('input-user')"
										v-validate="{ required: true }"
										data-vv-as="Usuário"
										:data-vv-name="'input-user'"
										:class="veeErrors.has('input-user') ? 'v-input--has-state error--text' : ''">
										<template v-slot:message="{message}">
											<span class="error--text">{{message}}</span>
										</template>
									</v-text-field>
								</v-col>
							</v-row>
							<v-row dense>
								<v-col col='12' sm='8' offset-sm='2'>
									<v-text-field label="Senha" type='password' :disabled="computedLoading" 
										v-model="login.password" outlined dense id="input-password"
										@keyup.enter="onSubmit"
										:messages="veeErrors.first('input-password')"
										v-validate="{ required: true }"
										data-vv-as="Senha"
										:data-vv-name="'input-password'"
										:class="veeErrors.has('input-password') ? 'v-input--has-state error--text' : ''">
										<template v-slot:message="{message}">
											<span class="error--text">{{message}}</span>
										</template>
									</v-text-field>
								</v-col>
							</v-row>
							<v-row dense>
								<v-col col='12' sm='8' offset-sm='2' class="text-center mb-4">
									<v-btn class="primary--text" type="submit" @click="onSubmit" :loading='computedLoading' elevation='0'>Entrar</v-btn>
								</v-col>
							</v-row>
						
					</v-card-text>
				</v-card>				
			</v-col>

			<v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>

			<v-col cols="12" md="6">
				<v-card elevation='0' >
					<v-card-title class="text-h5">
						Instruções de Acesso
					</v-card-title>
					<v-card-text>
						<div> Para acessar digite o usuário e senha que você utiliza para acessar o portal do professor (RM) </div>
						<div class="instrucoes-login">
							<samp>
								<div><b>Usuário:</b> Os primeiros 9 dígitos do CPF (somente números) </div>
								<div><b>Senha:</b> Senha do portal do professor </div>
							</samp>
						</div>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>


	</div>
</template>

<script>

import FrontendConfigService from '@/services/configs/frontendConfigService'
export default {
	name: 'Login',
	data(){
		return {
			login:{
				username:'',
				password:''
			},
		}
	},
	methods:{
		veeValidateField(ref) {
            if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        onSubmit(){
            this.$validator.validateAll()
                .then(success => {
                    // vee Validation
                    if (!success) return;

					this.$store.loginStore.commit('setLoading', true)
					const request = this.$store.loginStore.dispatch('acessar', this.login)
					request.then(response => {
						//console.log('response',response)
						//ao logar, salvar usuário autenticado
						this.$store.loginStore.commit('iniciarSessao', {callback:response.data, login: this.login})
						this.$router.push({name:'agenda'})
					})
					.catch( (error) => {
						let msg = 'Usuário e/ou Senha inválidos!'
						try{
							const keys = Object.keys(error.response.data)
							try{
								msg = error.response.data[keys[0]][0]
							}catch{
								msg = error.response.data[keys[0]]
							}
						}catch(err){
							console.log('catch', err)
						}
						console.log(error.response)
						this.$store.loginStore.commit('encerrar')
						this.$store.loginStore.commit('setNotifications', [{'tag':'error', 'message': msg}])
					})
					.finally(()=>{
						this.$store.loginStore.commit('setLoading', false)
					})
                })
                .catch( error => {
					console.error('onSubmit', error)  
                });
        },
	},
	computed:{
		computedLoading(){ return this.$store.loginStore.state.loading } ,
		computedNotifications(){ return this.$store.loginStore.getters.getNotifications }
	},
	watch:{
		computedNotifications:{
            handler(errors){
                for(let message of errors){
                    let options = FrontendConfigService.getOptionsToast()
                    //console.log(`${message.tag} - ${message.message} ${message.title}- ${options}`);
                    this.$toast(message.message, {
                        type: message.tag,
                        ...options
                    })
                }
            }, deep:true
        }
	}
}
</script>
